import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Box } from '@mui/material';

import {
  ChannelDetail,
  VideoDetail,
  SearchFeed,
  Navbar,
  Feed,
} from './components';

const App = () => (
  <Router>
    <Box
      sx={{
        p: 1,
        bgcolor: '#000',
      }}
    >
      <Navbar />
      <Routes>
        <Route exact path='/' element={<Feed/>} />
        <Route path='/video/:id' element={<VideoDetail/>} />
        <Route path='/channel/:id' element={<ChannelDetail/>} />
        <Route path='/search/:searchTerm' element={<SearchFeed/>} />
      </Routes>
    </Box>
  </Router>
);

export default App;
